import {Superheroes} from "./superheroes";
import {Countries} from "./countries";
import {DisneyPrincesses} from "./disney-princesses";
import {CommonNouns} from "./common-nouns";
import {EnglishCounties} from "./counties";

function parseDatalist(data) {
    const lines = data.trim().split("\n");
    return lines.filter(Boolean).map(line => {
        const cols = line.split(",").map(s => s.trim());
        return {
            name: cols[0],
            spellings: cols.filter(Boolean)
        };
    });
}

export const Categories = [
    {
        "name": "Countries of the World",
        "description": "According to gov.uk",
        "entries": parseDatalist(Countries)
    },
    {
        "name": "Ceremonial Counties of England",
        "description": "According to gov.uk",
        "entries": parseDatalist(EnglishCounties)
    },
    {
        "name": "Common Nouns",
        "entries": parseDatalist(CommonNouns)
    },
    // {
    //     "name": "Superheroes",
    //     "entries": parseDatalist(Superheroes)
    // },
    // {
    //     "name": "Disney Characters",
    //     "entries": parseDatalist(DisneyPrincesses)
    // },
];